import { render, staticRenderFns } from "./EventContainerFlipOverlay.vue?vue&type=template&id=36c26d75&"
import script from "./EventContainerFlipOverlay.vue?vue&type=script&lang=js&"
export * from "./EventContainerFlipOverlay.vue?vue&type=script&lang=js&"
import style0 from "./EventContainerFlipOverlay.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VOverlay})
